import { useState, useCallback } from 'react';

/**
 * Small hook to manage a photo lightbox's open state + current index.
 */
export const useLightbox = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const openAt = useCallback((i) => {
    setIndex(i);
    setOpen(true);
  }, []);

  const close = useCallback(() => setOpen(false), []);

  return { open, index, setIndex, openAt, close };
};
